import React from 'react'
import LoadingSpinner from '../components/UI/LoadingSpinner'
import MessageAlert from '../components/UI/MessageAlert'
import GlassPanel from '../components/UI/GlassPanel'
import EventTypeGrid from '../components/EventTypeGrid'
import ArtistSelector from '../components/ArtistSelector'
import ArtistStatsDisplay from '../components/ArtistStatsDisplay'
import HeadlineStats from '../components/Stats/HeadlineStats'
import DiscoveriesSection from '../components/Stats/DiscoveriesSection'
import ArtistHistorySection from '../components/Stats/ArtistHistorySection'
import MissedArtistsSection from '../components/Stats/MissedArtistsSection'
import VenuesSection from '../components/Stats/VenuesSection'
import DeepStatsSection from '../components/Stats/DeepStatsSection'
import { useStats } from '../hooks/useStats'
import { useArtistStats } from '../hooks/useArtistStats'
import { useArtistFavorite } from '../hooks/useArtistFavorite'

const Stats = () => {
  const { stats, loading, error, refetch } = useStats()
  const { selectedArtist, artistStats, error: artistError, handleArtistSelect } = useArtistStats()
  const { toggleLoved, error: favoriteError } = useArtistFavorite(refetch)

  if (loading) {
    return (
      <div className="p-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center justify-center h-64">
            <LoadingSpinner text="Loading statistics..." />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="p-8">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-white mb-2">📊 Event Statistics</h1>
          <p className="text-gray-300">Your music journey at a glance</p>
        </div>

        <MessageAlert message={error || artistError || favoriteError} type="error" />

        <HeadlineStats headlines={stats.headlines} eventsByYear={stats.eventsByYear} />

        <DiscoveriesSection
          discoveries={stats.discoveries}
          onToggleLoved={toggleLoved}
        />

        <ArtistHistorySection
          artistHistory={stats.artistHistory}
          favoriteArtists={stats.favoriteArtists}
        />

        <MissedArtistsSection missedArtists={stats.missedArtists} />

        <VenuesSection venues={stats.venues} places={stats.places} />

        <DeepStatsSection
          deep={stats.deep}
          lineupCoverage={stats.lineupCoverage}
          genres={stats.genres}
        />

        {/* Event Type Breakdown */}
        <GlassPanel className="p-6 mb-8">
          <h2 className="text-xl font-bold text-white mb-4">Events by Type</h2>
          <EventTypeGrid eventsByType={stats.eventsByType} />
        </GlassPanel>

        {/* Artist Explorer */}
        <GlassPanel className="p-6">
          <h2 className="text-xl font-bold text-white mb-4">🎤 Artist Explorer</h2>

          <ArtistSelector
            artists={stats.allArtists}
            selectedArtist={selectedArtist}
            onArtistSelect={handleArtistSelect}
          />

          <ArtistStatsDisplay
            artistStats={artistStats}
            selectedArtist={selectedArtist}
          />
        </GlassPanel>
      </div>
    </div>
  )
}

export default Stats